<template>
  <div class="carouselIndu">
    <section class="carouselIndu__track">
      <div class="carousel__container">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="['carousel__item', `carousel__item-${(index % 8) + 1}`]"
        >
          <h3>{{ item }}</h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CarouselIndu',
  data() {
    const industries = [
      'Telecom', 'Airline', 'Cloud', 'Pharma',
      'Financial', 'Events', 'Energy', 'Hotels'
    ];
    return {
      // Repeat the array 3x for seamless scrolling
      items: [...industries, ...industries, ...industries]
    };
  }
};
</script>

<style scoped>
@import '@/assets/css/Variables.css';

.carouselIndu {
  height: 280px;
  width: 100%;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.carouselIndu__track {
  width: 100%;
  display: flex;
  justify-content: center;
}

.carousel__container {
  display: flex;
  animation: scroll 30s linear infinite;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.carousel__item {
  background-color: $light-gray;
  opacity: 0.6;
  width: 300px;
  height: 200px;
  border-radius: 20px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 450ms all;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  flex-shrink: 0;
  padding: 1rem;
}

.carousel__item h3 {
  font-weight: $font-thick;
  font-size: $font-med;
  color: $black;
  text-shadow: 1px 1px 2px white;
}

/* Background images based on index (loop 8) */
.carousel__item-1 {
  background-image: url(../assets/images/ZpvRUF9.jpg);
}
.carousel__item-2 {
  background-image: url(../assets/images/kaZ1miU.jpg);
}
.carousel__item-3 {
  background-image: url(../assets/images/vW63Non.jpg);
}
.carousel__item-4 {
  background-image: url(../assets/images/96AIFvU.jpg);
}
.carousel__item-5 {
  background-image: url(../assets/images/C5saJiG.jpg);
}
.carousel__item-6 {
  background-image: url(../assets/images/kaY5tJR.jpg);
}
.carousel__item-7 {
  background-image: url(../assets/images/k9m2WA7.jpg);
}
.carousel__item-8 {
  background-image: url(../assets/images/j4n0evW.jpg);
}

/* Hover effects */
.carousel__container:hover .carousel__item {
  opacity: 0.2;
}
.carousel__container:hover .carousel__item:hover {
  transform: scale(1.1);
  opacity: 1;
}
</style>
